import { Button } from "@Light/components/page/Button";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { Field } from "@Light/components/system/Fieldset";
import { Input } from "@Light/components/system/Input";
import { useScaffold } from "@Light/scaffold";
import { EnrollBottomSheet } from "../common/EnrollBottomSheet";
import { EnrollHelpButton } from "../EnrollHelpButtonFooter";
import type { UseUtilityAccountNumberSearch } from "./useUtilityAccountNumberSearch";

export type UtilityAccountNumberBottomSheetProps =
  UseUtilityAccountNumberSearch & {
    open: boolean;
    onClose: () => void;
    onClickUseAddress?: () => void;
  };

export const UtilityAccountNumberBottomSheet = ({
  field,
  onSubmit,
  isLoading,
  error,
  open,
  onClose,
  onClickUseAddress,
}: UtilityAccountNumberBottomSheetProps) => {
  const scaffold = useScaffold();
  const ErrorMessage = scaffold.system.errorMessage;

  return (
    <EnrollBottomSheet
      open={open}
      onClose={onClose}
      title="What’s your ESI ID?"
      subtitle="Use the Electric Service Identifier found on past electricity bills to determine your location’s eligibility."
      data-testid="utility-account-number-sheet"
      footer={
        <ButtonFooter>
          <Button
            size="lg"
            className="w-full"
            disabled={isLoading}
            onClick={() => {
              void onSubmit();
            }}
            data-testid="utility-account-number-sheet-submit"
          >
            View offer
          </Button>
          <EnrollHelpButton
            eventVariant="utility_account_number_sheet"
            onClick={onClose}
          />
        </ButtonFooter>
      }
    >
      <Field className="flex flex-col gap-1.5">
        <Input
          {...field}
          isError={!!error}
          isLoading={isLoading}
          aria-label="ESI ID"
          data-record="true"
          data-testid="utility-account-number-sheet-input"
        />
        {error ? (
          <ErrorMessage data-testid="utility-account-number-sheet-error">
            {error}
          </ErrorMessage>
        ) : null}
        {onClickUseAddress ? (
          <p className="text-sm text-tertiary">
            Want to use address?{" "}
            <button
              type="button"
              onClick={onClickUseAddress}
              data-testid="utility-account-number-sheet-use-address"
              className="cursor-pointer underline underline-offset-4"
            >
              Switch to address search
            </button>
          </p>
        ) : null}
      </Field>
    </EnrollBottomSheet>
  );
};
